<div [class.visually-hidden]="isMobile">
  <ng-container *ngTemplateOutlet="menuItems"></ng-container>
</div>

<div
  class="tabs dropdown"
  *ngIf="isMobile">
  <a
    class="dropdown-toggle"
    [appDropdown]="menuItems"
    [appDropdownOptions]="{ fullWidth: true, maxHeight: false }"
    (shown)="isOpen = true"
    (hidden)="isOpen = false">
    {{ activeItemName }}
    <app-icon
      name="triangle-arrow"
      classes="{{ isOpen ? '__up' : '' }}"
      style="position: relative; left: 5px; top: 1px"></app-icon>
  </a>
</div>

<ng-template #menuItems>
  <ng-content></ng-content>
</ng-template>
